// extracted by mini-css-extract-plugin
export default {"col":"GeneratePicklList_col__nTW5q","subtitle":"GeneratePicklList_subtitle__X8CYf"};